<template>
  <div class="position-relative d-none" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col cols="12" class="position-static d-flex align-items-center justify-content-between">
          <!-- Logo -->
          <a :href="`${baseUrl}`" class="d-block ">
            <div class="py-3 h-100">
              <img :src="require('@/assets/img/logo/logo-kle.svg')" alt="en" class="img img-fluid logo-header" />
            </div>
          </a>
          <!-- /Logo -->
          <nav class="main-navigation d-none d-md-inline-block">
            <ul class="d-flex align-items-center justify-content-center list-unstyled m-0 p-0">
              <li class="">
                <a target="_blank" :href="`${baseUrl}/kreis-kleve`" class="">
                  Kreis Kleve
                </a>
              </li>
              <li class="">
                <a target="_blank" :href="`${baseUrl}/service`" class="">
                  Service
                </a>
              </li>
              <li class="">
                <a target="_blank" :href="`${baseUrl}/aufgaben`" class="">
                  Aufgaben
                </a>
              </li>
            </ul>
          </nav>
          <div class="logo-header d-none d-xl-block"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

const KREIS_KLEVE_BASE_URL = 'https://www.kreis-kleve.de';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class HeaderInformationNavigationEn extends Vue {
  get baseUrl() {
    return KREIS_KLEVE_BASE_URL;
  }

  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de';
  }

  get quickLinks() {
    const base = this.baseUrl;
    return [
      { href: `${base}/kreis-kleve/jobs-und-karriere/stellenangebote-des-kreises-kleve`, title: 'Aktuelle Stellenangebote', text: 'Aktuelle Stellenangebote' },
      { href: `${base}/service`, title: 'Alle Dienstleistungen', text: 'Alle Dienstleistungen' },
      { href: `${base}/kreis-kleve/jobs-und-karriere/ausbildung-der-kreisverwaltung-kleve`, title: 'Ausbildung bei der Kreisverwaltung', text: 'Ausbildung bei der Kreisverwaltung' },
      { href: `${base}/aufgaben/migration/auslaenderbehoerde`, title: 'Ausländerbehörde', text: 'Ausländerbehörde' },
      { href: `${base}/leichte-sprache`, title: 'Barrierefreiheit / Leichte Sprache', text: 'Barrierefreiheit / Leichte Sprache' },
      { href: 'https://www.berufskolleg-geldern.de/', title: 'BK Geldern', text: 'Berufskolleg Geldern' },
      { href: 'https://www.berufskolleg-kleve.de/', title: 'BK Kleve', text: 'Berufskolleg Kleve' },
      { href: `${base}/kreis-kleve/politik-und-kreistag/buergerentscheid-nationalpark-reichswald`, title: 'Bürgerentscheid Nationalpark Reichswald', text: 'Bürgerentscheid "Nationalpark Reichswald"' },
      { href: `${base}/de/inhalt/elektronische-kommunikation`, title: 'elektronische Kommunikation', text: 'elektronische Kommunikation' },
      { href: `${base}/aufgaben/auto-mobilitaet-strassenverkehr/fuehrerschein`, title: 'Führerschein', text: 'Führerschein' },
      { href: `${base}/aufgaben/auto-mobilitaet-strassenverkehr/kfz-zulassung`, title: 'Kfz-Zulassung', text: 'Kfz-Zulassung' },
      { href: 'https://meinjob-kreis-kleve.de/', title: '"MeinJob" - kreisweites Jobportal', text: '"MeinJob" - kreisweites Jobportal' },
      { href: `${base}/kreis-kleve/online-dienste`, title: 'Online-Dienste Kreis Kleve', text: 'Online-Dienste Kreis Kleve' },
      { href: `${base}/schwerbehindertenausweis`, title: 'Schwerbehinderten-Ausweise', text: 'Schwerbehinderten-Ausweise' },
      { href: 'https://veranstaltungen-kreis-kleve.de/de/', title: 'Veranstaltungskalender der WFG', text: 'Veranstaltungskalender der WFG' },
      { href: `${base}/wunschkennzeichen`, title: 'Wunschkennzeichen', text: 'Wunschkennzeichen' },
    ];
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    width: 178px;
  }
  .main-nav-item {
    margin: 0 3px 0 0;
  }
  .main-nav-link {
    color: #68726A;
    font-weight: 500;
    background-color: #EEF1F0;
    padding: 5px 15px;
    margin: 5px 0;
    border-radius: 5px;
    transition: none;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
    &:hover, &:active {
      background-color: var(--portal-primary);
      color: #ffffff!important;
    }
  }
  .main-nav-link-btn {
    font-weight: 500;
    padding: 5px 15px;
    margin: 5px 0;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
  }
  .auth-cabinet .logo-header {
    height: auto;
  }
}

.main-nav-list {
  padding: 0.625rem 1.125rem;
  margin: 0 0 1rem;
  background: transparent;
}
.main-nav-link-wrapper {
  >a, >a:visited, >a:active, >a:hover {
    color: rgb(var(--portal-secondary-600));
    text-decoration: none;
  }
}

//sub-nav
.main-nav-item--dropdown,
.main-nav-item--dropdown .main-nav-link-wrapper {
  overflow: visible;
}
ul.main-nav-list li:hover div > ul {
  visibility: visible;
  opacity: 1;
}
ul.main-nav-list ul {
  list-style: none;
  margin: 5px 0 0;
  padding: 10px 0 0;
  visibility: hidden;
  position: absolute;
  z-index: 99999;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear, visibility 0.2s linear;
  -moz-transition: opacity 0.2s linear, visibility 0.2s linear;
  -o-transition: opacity 0.2s linear, visibility 0.2s linear;
  transition: opacity 0.2s linear, visibility 0.2s linear;
  top: 100%;
  left: 0px;
  text-transform: none;
  font-weight: 600;
  line-height: 1.4em;
  -moz-box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: 250px;
  overflow: hidden;
  background: var(--portal-primary);
}
ul.main-nav-list ul.quicklinks {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 800px;
  max-width: min(800px, calc(100vw - 24px));
  padding: 12px 20px 16px;
  gap: 5px 40px;
  left: 40%;
  transform: translateX(-40%);
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    width: min(280px, calc(100vw - 24px));
    max-width: min(280px, calc(100vw - 24px));
    left: 50%;
    transform: translateX(-50%);
  }
}

ul.main-nav-list ul li {
  clear: both;
  width: 100%;
  background: none transparent;
}
ul.main-nav-list ul li {
  display: inline;
  float: left;
  margin: 0;
  padding: 0;
  position: relative;
  background-image: none;
  border-radius: 5px;
  margin-right: 2px;
}
ul.main-nav-list ul.quicklinks li {
  float: none;
  display: block;
  margin-right: 0;
  width: auto;
}
ul.main-nav-list ul li a {
  padding: 3px 10px 3px 12px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: block;
  border: 0 none;
  clear: both;
  border-radius: 0px;
  background-color: transparent;
}
ul.main-nav-list ul li a:hover,
ul.main-nav-list ul li.active a {
  color: white;
}
ul.main-nav-list ul li:last-child a {
  padding: 3px 10px 12px 12px;
}
ul.main-nav-list ul.quicklinks li a {
  padding: 4px 0;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 14px;
}
ul.main-nav-list ul.quicklinks li:last-child a {
  padding: 4px 0;
}
@media (max-width: 991.98px) {
  .main-nav-item:not(:last-child){
   border-bottom: none;
}
}

@media (max-width: 991.98px) {
  .main-nav-item {
     margin: 0 3px 0 0!important;
    width: inherit;
    padding: 0;
  }
}

.main-navigation {
  ul {
    gap: 30px;
    li {
      a {
        color: #000;
        display: block;
        font-size: 1.3rem;
        font-weight: 400;
        justify-content: center;
        line-height: 2.625rem;
        padding: .4375rem 1rem;
        text-decoration: none;
        @media (min-width: 991.98px) {
          font-size: 1.875rem;
        }
        &:hover {
          color: var(--portal-primary);
        }
      }
    }
  }
}
</style>
